import get from 'lodash/get';
import { Route } from 'react-router-dom';
import { Redirect } from '../components/redirect';
import { RouterContext } from '../contexts';
import { consumeRedirectURL } from 'src/_shared/services/redirectAfterLogin.js';

export function UnauthenticatedRoute(props) {
	const { component: Component } = props;
	const routeData = get(props, 'routeData');
	const rest = { ...props };
	delete rest.component;
	return (
		<RouterContext.Consumer>
			{({ auth }) => (
				<Route
					{...rest}
					render={(props) => {
						if (auth) {
							// Router state is present when the login page was reached in
							// this tab's history. After a full-page round trip (SSO via
							// Cognito Hosted UI, or a hard redirect through /logout) it is
							// gone, so fall back to the stored destination. (ERIN-8413)
							const stored = consumeRedirectURL(null);
							const redirectURL =
								props.location?.state?.redirectURL ?? stored ?? '/dashboard';
							return <Redirect loc={redirectURL} nav={props} />;
						}

						return <Component {...props} routeData={routeData} />;
					}}
				/>
			)}
		</RouterContext.Consumer>
	);
}
